/*
 * Javascript for search [age]
*/
(function($) {
	if($('body.search').length) {
		$(document).on('submit', 'form', function(){
			showLoadingBar();
		});
		$(document).on('change', '.limit', function(){
			var limit = $(this).find(":selected").val();

			var queryParameters = {}, queryString = location.search.substring(1),re = /([^&=]+)=([^&]*)/g, m;

			// Creates a map with the query string parameters
			while (m = re.exec(queryString)) {
				queryParameters[decodeURIComponent(m[1])] = m[2];
			}

			// Add new parameters or update existing ones
			queryParameters['limit'] = limit;

			var url = document.location.href;
			var mainurl = url.split("?");
			showLoadingBar();
			var query = $.param(queryParameters).replace('%2B','+');
			window.location.href = mainurl[0]+'?'+query;
		});
		$(document).on('change', '.filter', function(){
			var filter = $(this).find(":selected").val();
			if((filter !== '') && (filter !== getUrlParameter('filter'))) {
				var queryParameters = {}, queryString = location.search.substring(1),re = /([^&=]+)=([^&]*)/g, m;

				// Creates a map with the query string parameters
				while (m = re.exec(queryString)) {
					queryParameters[decodeURIComponent(m[1])] = m[2];
				}

				// Add new parameters or update existing ones
				queryParameters['filter'] = filter;


				var url = document.location.href;
				var mainurl = url.split("?");
				showLoadingBar();
				var query = $.param(queryParameters).replace('%2B','+');
				window.location.href = mainurl[0]+'?'+query;
			}
		});
	}
})(jQuery);
